import { Rocket as RocketIcon } from "lucide-react";
import { MANTRAS } from "@/data/site";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MANTRAS.map((m) => (
      <span key={m} className="flex items-center">
        <span className="px-8 font-display text-2xl sm:text-3xl font-semibold tracking-wide text-cream">
          {m}
        </span>
        <RocketIcon className="h-5 w-5 text-honey" />
      </span>
    ))}
  </div>
);

export const Marquee = ({ className = "" }) => (
  <div
    className={`marquee-paused overflow-hidden bg-brand py-5 ${className}`}
    data-testid="mantra-marquee"
    aria-hidden="true"
  >
    <div className="animate-marquee-slow flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
